module.exports = __webpack_public_path__ + "img/system17-details.c169d81f.png";